import produce from 'immer';
import {
  GET_STORE_PRODUCTS_SUCCESS,
  GET_STORE_PRODUCTS_START,
  GET_STORE_PRODUCTS_FAILED,
  EDIT_STORE_PRODUCT_START,
  EDIT_STORE_PRODUCT_SUCCESS,
  EDIT_STORE_PRODUCT_FAILED,
  DELETE_STORE_PRODUCT_START,
  DELETE_STORE_PRODUCT_SUCCESS,
  DELETE_STORE_PRODUCT_FAILED,
  SAVE_ONE_TIME_PURCHASE_PRODUCT_ATTR_SUCCESS,
  GET_EDITABLE_STORE_PRODUCT_START,
  GET_EDITABLE_STORE_PRODUCT_SUCCESS,
  GET_EDITABLE_STORE_PRODUCT_FAILED,
  EDIT_USER_STORE_PRODUCTS,
  EDIT_USER_STORE_PRODUCT_DESCRIPTION,
  CATEGORY_PRODUCTS_SUCCESS,
  GET_CATEGORY_PRODUCTS_START,
  GET_CATEGORY_PRODUCTS_FAILED,
  UPDATE_CATEGORY_PRODUCTS,
  CHANGE_PRODUCT_CATEGORIES,
  SAVE_CATEGORY_PRODUCTS_START,
  SAVE_CATEGORY_PRODUCTS_SUCCESS,
  SAVE_CATEGORY_PRODUCTS_FAILED,
  SAVE_PRODUCT_CATEGORIES_START,
  SAVE_PRODUCT_CATEGORIES_SUCCESS,
  SAVE_PRODUCT_CATEGORIES_FAILED,
  GET_MASTER_CATALOG_PRODUCTS_START,
  GET_MASTER_CATALOG_PRODUCTS_SUCCESS,
  GET_MASTER_CATALOG_PRODUCTS_FAILED,
  CREATE_NEW_SUBSCRIPTION_OPTION,
  EDIT_NEW_SUBSCRIPTION_OPTION,
  ADD_SUBSCRIPTION_OPTION_START,
  SET_SUBSCRIPTION_OPTIONS,
  ADD_SUBSCRIPTION_OPTION_FAILED,
  ADD_SUBSCRIPTION_OPTION_SUCCESS,
  CHANGE_PRODUCT_SUBSCRIPTION_INSTALMENT_PRICE,
  CANCEL_ADD_SUBSCRIPTION_OPTION,
  EDIT_SUBSCRIPTION_OPTION_START,
  EDIT_SUBSCRIPTION_OPTION_SUCCESS,
  EDIT_SUBSCRIPTION_OPTION_FAILED,
  DELETE_ONE_TIME_SUBSCRIPTION_OPTION_START,
  DELETE_ONE_TIME_SUBSCRIPTION_OPTION_SUCCESS,
  DELETE_ONE_TIME_SUBSCRIPTION_OPTION_FAILED,
  DELETE_SUBSCRIPTION_OPTION,
  SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_START,
  SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_SUCCESS,
  SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_FAILED,
  SET_CUSTOM_OPTIONS,
  ADD_CUSTOM_OPTION_START,
  ADD_CUSTOM_OPTION_SUCCESS,
  ADD_CUSTOM_OPTION_FAILED,
  DELETE_CUSTOM_OPTION_START,
  DELETE_CUSTOM_OPTION_SUCCESS,
  DELETE_CUSTOM_OPTION_FAILED,
  DELETE_CUSTOM_OPTION_VALUE_START,
  DELETE_CUSTOM_OPTION_VALUE_FAILED,
  EDIT_CUSTOM_OPTION_START,
  EDIT_CUSTOM_OPTION_SUCCESS,
  EDIT_CUSTOM_OPTION_FAILED,
  DELETE_CUSTOM_OPTION_VALUE_SUCCESS,
  GET_CUSTOM_OPTION_VALUE_BY_ID_START,
  GET_CUSTOM_OPTION_VALUE_BY_ID_FAILED,
  GET_CUSTOM_OPTION_VALUE_BY_ID_SUCCESS,
  GET_CUSTOM_OPTIONS_PRICE_TYPES_START,
  GET_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS,
  GET_CUSTOM_OPTIONS_PRICE_TYPES_FAILED,
  SAVE_CUSTOM_OPTIONS_PRICE_TYPES_START,
  SAVE_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS,
  SAVE_CUSTOM_OPTIONS_PRICE_TYPES_FAILED,
  ADD_PRODUCT_TO_STORE_START,
  ADD_PRODUCT_TO_STORE_SUCCESS,
  ADD_PRODUCT_TO_STORE_FAILED,
  MASS_ADD_PRODUCT_TO_STORE_START,
  MASS_ADD_PRODUCT_TO_STORE_SUCCESS,
  MASS_ADD_PRODUCT_TO_STORE_FAILED,
  GET_FBT_LINKS_START,
  GET_FBT_LINKS_SUCCESS,
  GET_FBT_LINKS_FAILED,
  SAVE_FBT_LINKS_START,
  SAVE_FBT_LINKS_SUCCESS,
  SAVE_FBT_LINKS_FAILED,
  REMOVE_FBT_LINK_START,
  REMOVE_FBT_LINK_SUCCESS,
  REMOVE_FBT_LINK_FAILED,
  ADD_UPSELL_LINKS,
  ADD_CROSS_SELL_LINKS,
  SEND_DIRECT_FULFILLMENT_REQUEST_START,
  SEND_DIRECT_FULFILLMENT_REQUEST_SUCCESS,
  SEND_DIRECT_FULFILLMENT_REQUEST_FAILED,
  GET_STORE_PRODUCTS_EXPORT_START,
  GET_STORE_PRODUCTS_EXPORT_SUCCESS,
  GET_STORE_PRODUCTS_EXPORT_FAILED,
  ADD_TO_MASS_EDIT,
  EDIT_STORE_PRODUCT_UPSELL_START,
  EDIT_STORE_PRODUCT_UPSELL_SUCCESS,
  EDIT_STORE_PRODUCT_UPSELL_FAILED,
  REMOVE_STORE_PRODUCT_RELATED_LINKS_START,
  REMOVE_STORE_PRODUCT_RELATED_LINKS_SUCCESS,
  REMOVE_STORE_PRODUCT_RELATED_LINKS_FAILED,
  EDIT_STORE_PRODUCT_CROSS_SELL_START,
  EDIT_STORE_PRODUCT_CROSS_SELL_SUCCESS,
  EDIT_STORE_PRODUCT_CROSS_SELL_FAILED,
  SAVE_STORE_PRODUCT_MEDIA_GALLERY_START,
  SAVE_STORE_PRODUCT_MEDIA_GALLERY_SUCCESS,
  SAVE_STORE_PRODUCT_MEDIA_GALLERY_FAILED,
  GET_STORE_TAX_CLASSES_START,
  GET_STORE_TAX_CLASSES_SUCCESS,
  GET_STORE_TAX_CLASSES_FAILED,

  GET_ALL_TASKS_FROM_QUEUE_START,
  GET_ALL_TASKS_FROM_QUEUE_SUCCESS,
  GET_ALL_TASKS_FROM_QUEUE_FAILED,
  ADD_TASKS_TO_QUEUE_START,
  ADD_TASKS_TO_QUEUE_SUCCESS,
  ADD_TASKS_TO_QUEUE_FAILED,
  REMOVE_TASK_FROM_QUEUE_START,
  REMOVE_TASK_FROM_QUEUE_SUCCESS,
  REMOVE_TASK_FROM_QUEUE_FAILED,
  RECEIVE_QUEUED_TASK_UPDATE,
  ADD_PATIENT_CERTIFICATION_START,
  SET_PATIENT_CERTIFICATION_START,
  SET_PATIENT_CERTIFICATION_SUCCESS,
  SET_PATIENT_CERTIFICATION_FAILED,
  ADD_PATIENT_CERTIFICATION_SUCCESS,
  ADD_PATIENT_CERTIFICATION_FAILED,
  EDIT_PATIENT_CERTIFICATION_START,
  EDIT_PATIENT_CERTIFICATION_SUCCESS,
  EDIT_PATIENT_CERTIFICATION_FAILED,
  DELETE_PATIENT_CERTIFICATION_START,
  DELETE_PATIENT_CERTIFICATION_SUCCESS,
  DELETE_PATIENT_CERTIFICATION_FAILED
} from '../actions/products';

import {
  CREATE_STORE_CATEGORY_SUCCESS
} from '../actions/categories';
import {
  CHANGE_ACTIVE_STORE_SUCCESS
} from '../actions/user';

import {
  ADD_USER_STORE_SUCCESS,
} from '../actions/admin';


// certification_family is the option template group a store builds this certification from, and
// the key the product page matches on. option_title_id is kept for the certifications created
// before templates were used - those carry no group and would otherwise disappear from the list.
const certifications = [
  {
    product_sku: '',
    title: 'Toxin Contraindications',
    type: 'checkbox',
    sort_order: 15,
    is_require: true,
    option_title_id: 'certification_toxin',
    certification_family: 'Toxin Contraindications',
    price: 0,
    price_type: '',
    file_extension: '',
    max_characters: 0,
    image_size_x: 0,
    image_size_y: 0,
    is_swatch: false,
    dermpro_option_gallery: 0,
    dermpro_option_image_mode: 0,
    values: [
      {
        title: 'I certify that I am not pregnant or breastfeeding, and I do not have a muscle or nerve condition including myasthenia gravis, Amyotrophic Lateral Sclerosis (ALS) or Lambert-Eaton syndrome.',
        sort_order: 1,
        price: 0,
        price_type: 'fixed',
        images: []
      }
    ]
  },
  {
    product_sku: '',
    title: 'Filler Contraindications.',
    type: 'checkbox',
    sort_order: 1,
    is_require: true,
    option_title_id: 'certification_filler',
    certification_family: 'Filler Contraindications',
    price: 0,
    price_type: '',
    sku: '',
    file_extension: '',
    max_characters: 0,
    image_size_x: 0,
    image_size_y: 0,
    is_swatch: false,
    dermpro_option_gallery: 2,
    dermpro_option_image_mode: 1,
    values: [
      {
        title: 'I certify that I am not pregnant or breastfeeding, and I do not have a connective tissue disorder such as lupus.',
        sort_order: 1,
        price: 0,
        price_type: '',
        sku: '',
        images: []
      }
    ]
  },
  {
    product_sku: '',
    title: 'Latisse Certification',
    type: 'checkbox',
    sort_order: 1,
    is_require: true,
    option_title_id: 'certification_latisse',
    certification_family: 'Latisse Certification',
    price: 0,
    price_type: '',
    sku: '',
    file_extension: '',
    max_characters: 0,
    image_size_x: 0,
    image_size_y: 0,
    is_swatch: false,
    dermpro_option_gallery: 2,
    dermpro_option_image_mode: 1,
    values: [
      {
        title: 'I certify that I am a patient of this practice and have a valid prescription on file, and that I do not have any medical conditions such as eye disease, glaucoma or drug allergies & I am not pregnant.',
        sort_order: 1,
        price: 0,
        price_type: '',
        sku: '',
        images: []
      }
    ]
  },
  {
    product_sku: '',
    title: 'CoolSculpting Contraindications',
    type: 'checkbox',
    sort_order: 1,
    is_require: true,
    option_title_id: 'certification_cool_sculpting',
    certification_family: 'CoolSculpting Contraindications',
    price: 0,
    price_type: '',
    sku: '',
    file_extension: '',
    max_characters: 0,
    image_size_x: 0,
    image_size_y: 0,
    is_swatch: false,
    dermpro_option_gallery: 2,
    dermpro_option_image_mode: 1,
    values: [
      {
        title: 'I certify that I do not have a condition that causes sensitivity to cold, such as Cold Urticaria or Raynaud\'s Disease, Cryoglobulinemia, or Paroxysmal Cold Hemoglobinuria. I am not pregnant or breastfeeding.',
        sort_order: 1,
        price: 0,
        price_type: '',
        sku: '',
        images: []
      }
    ]
  },
  {
    product_sku: '',
    title: 'Pregnancy Certification',
    type: 'checkbox',
    sort_order: 1,
    is_require: true,
    option_title_id: 'certification_pregnancy',
    certification_family: null,
    price: 0,
    price_type: '',
    sku: '',
    file_extension: '',
    max_characters: 0,
    image_size_x: 0,
    image_size_y: 0,
    is_swatch: false,
    dermpro_option_gallery: 2,
    dermpro_option_image_mode: 1,
    values: [
      {
        title: 'I certify that I am not pregnant, lactating or planning to become pregnant.',
        sort_order: 1,
        price: 0,
        price_type: '',
        sku: '',
        images: []
      }
    ]
  }
];

const initialState = {
  store_products: {
    catalogProducts: [],
    catalogActiveProducts: [],
    store_products_sku: [],
    count: 0
  },
  queueTasks: {},
  queueTasksSkus: {},
  category_products: {},
  categories_products_to_update: {},
  product_categories_to_update: [],
  selectedProductCategoriesIds: [],
  editable_product: {},
  editable_store_product_no_changes: {},
  editable_store_product: {},
  loadingEditableStoreProduct: false,
  newOption: {},
  productCustomOptions: [],
  customOptionPriceTypes: {},
  getCustomOptionPriceTypesLoading: false,
  saveCustomOptionPriceTypesLoading: false,
  subscriptionOptions: [],
  addSubscriptionOptionLoading: false,
  editableSubscriptionOption: {},
  user_prodcts: {},
  brand_products: [],
  brandProductsCount: 0,
  loadingBrandProducts: false,
  fbtData: [],
  fbtSkus: [],
  getFBTDataLoading: false,
  saveFBTLinksLoading: false,
  removeFBTLinksLoading: false,
  getFBTDataError: '',
  product_links: [],
  loading: false,
  error: false,
  productsLoading: false,
  productsError: false,
  categoryProductsLoading: false,
  categoryProductsError: false,
  updateCategoryProductsLoading: false,
  updateCategoryProductsError: false,
  saveProductCategoriesLoading: false,
  saveProductCategoriesError: false,
  addProductToStoreLoading: false,
  massAddProductToStoreLoading: false,
  editSubscriptionOptionLoading: false,
  deleteOneTimeSubscriptionOptionLoading: false,
  savingProductSubscriptionAttr: false,
  addCustomOptionLoading: false,
  editCustomOptionLoading: false,
  deleteCustomOptionLoading: false,
  deleteCustomOptionValueLoading: false,
  addProductToStoreError: false,
  failedPublishProducts: [],
  sendingFulfillmentRequest: false,
  storeProductsExport: [],
  loadingProductsExport: false,
  massEdit: {
    list: [],
    changedProductIds: null,
    productsType: ''
  },
  savingProductUpsellLinks: false,
  savingProductCrossSellLinks: false,
  removeProductRelatedLinks: false,
  savingProductMediaGallery: false,
  storeTaxClasses: [],
  patientCertification: certifications,
  loadingPatientCertification: false,
  loadingTaxClasses: false,
  savingProduct: false,
  deletingProduct: false,
  loadingTasksToQueue: false
};

const formReducer = produce((state: IProductsState = initialState, action) => {
  switch (action.type) {
    case GET_STORE_PRODUCTS_SUCCESS: {
      const {products} = action;

      state.store_products = products;
      state.store_products.store_products_sku = products.catalogProducts?.map((product) => product.sku);
      state.store_products.catalogActiveProducts = products.catalogProducts.filter((product) => product.status == 1);
      state.productsLoading = false;
      state.productsError = false;
      break;
    }
    case GET_STORE_PRODUCTS_START: {
      state.productsLoading = true;
      break;
    }
    case GET_STORE_PRODUCTS_FAILED: {
      state.productsLoading = false;
      state.productsError = true;
      break;
    }
    case EDIT_STORE_PRODUCT_START: {
      state.savingProduct = true;
      break;
    }
    case EDIT_STORE_PRODUCT_SUCCESS: {
      const {product, sku} = action;
      state.savingProduct = false;

      state.store_products.catalogProducts = state.store_products.catalogProducts.map((item) => item.sku === sku ? product : item);
      break;
    }
    case EDIT_STORE_PRODUCT_FAILED: {
      state.savingProduct = false;
      break;
    }

    case DELETE_STORE_PRODUCT_START: {
      state.deletingProduct = true;
      break;
    }
    case DELETE_STORE_PRODUCT_SUCCESS: {
      const {sku} = action;
      state.deletingProduct = false;

      state.store_products.catalogProducts = state.store_products.catalogProducts.filter((item) => item.sku !== sku);
      state.store_products.count = state.store_products.count - 1;
      break;
    }
    case DELETE_STORE_PRODUCT_FAILED: {
      state.deletingProduct = false;
      break;
    }

    case REMOVE_STORE_PRODUCT_RELATED_LINKS_START: {
      state.removeProductRelatedLinks = true;
      break;
    }
    case REMOVE_STORE_PRODUCT_RELATED_LINKS_SUCCESS: {
      const {product} = action;
      state.removeProductRelatedLinks = false;
      state.editable_store_product = {
        ...state.editable_store_product,
        product_links: product.product_links
      };
      break;
    }
    case REMOVE_STORE_PRODUCT_RELATED_LINKS_FAILED: {
      state.removeProductRelatedLinks = false;
      break;
    }

    case EDIT_STORE_PRODUCT_UPSELL_START: {
      state.savingProductUpsellLinks = true;
      break;
    }
    case EDIT_STORE_PRODUCT_UPSELL_SUCCESS: {
      const {product} = action;
      state.savingProductUpsellLinks = false;
      state.editable_store_product = {
        ...state.editable_store_product,
        product_links: product.product_links
      };
      break;
    }
    case EDIT_STORE_PRODUCT_UPSELL_FAILED: {
      state.savingProductUpsellLinks = false;
      break;
    }

    case EDIT_STORE_PRODUCT_CROSS_SELL_START: {
      state.savingProductCrossSellLinks = true;
      break;
    }

    case EDIT_STORE_PRODUCT_CROSS_SELL_SUCCESS: {
      const {product} = action;
      state.savingProductCrossSellLinks = false;
      state.editable_store_product = {
        ...state.editable_store_product,
        product_links: product.product_links
      };
      break;
    }
    case EDIT_STORE_PRODUCT_CROSS_SELL_FAILED: {
      state.savingProductCrossSellLinks = false;
      break;
    }

    case SAVE_ONE_TIME_PURCHASE_PRODUCT_ATTR_SUCCESS: {
      const {product, sku} = action;
      state.store_products.catalogProducts = state.store_products.catalogProducts.map((item) => item.sku === sku ? product : item);
      break;
    }
    case GET_EDITABLE_STORE_PRODUCT_START: {
      state.loadingEditableStoreProduct = true;
      break;
    }

    case GET_EDITABLE_STORE_PRODUCT_SUCCESS: {
      const {product} = action;

      state.editable_store_product_no_changes = product.product;
      state.editable_store_product = product.product;
      state.selectedProductCategoriesIds = state.editable_store_product.custom_attributes?.find((attr) => attr.attribute_code === 'category_ids').value;

      state.loadingEditableStoreProduct = false;
      state.error = false;
      break;
    }

    case GET_EDITABLE_STORE_PRODUCT_FAILED: {
      state.loadingEditableStoreProduct = false;
      break;
    }
    case EDIT_USER_STORE_PRODUCTS: {
      const {customProductValue} = action;
      const [key] = Object.keys(customProductValue);

      state.editable_store_product[key] = customProductValue[key];
      break;
    }
    case EDIT_USER_STORE_PRODUCT_DESCRIPTION: {
      const {value, key} = action;

      const hasAttribute = state.editable_store_product.custom_attributes.filter(
        (a) =>  a.attribute_code === key
      );

      if (hasAttribute.length > 0) {
        state.editable_store_product.custom_attributes = state.editable_store_product.custom_attributes.map((a) => (
          a.attribute_code === key ? {...a, value} : a
        ));
      } else {
        state.editable_store_product.custom_attributes.push({
          attribute_code: key,
          value
        });
      }

      break;
    }
    case GET_MASTER_CATALOG_PRODUCTS_START: {
      state.loadingBrandProducts = true;
      break;
    }
    case GET_MASTER_CATALOG_PRODUCTS_SUCCESS: {
      const {data, brand, brandType} = action;

      if (brand && brandType == 'prod') {
        state.brand_products = data.catalogProducts.filter((product) => product.sku.includes('SKUPROD') || product.sku.includes('SKUGIFT'));
        state.brandProductsCount = data.count;
      } else if (brand && brandType == 'treat') {
        state.brand_products = data.catalogProducts.filter((product) => product.sku.includes('SKUTREAT'));
        state.brandProductsCount = data.count;
      } else if (brand) {
        state.brand_products = data.catalogProducts;
        state.brandProductsCount = data.count;
      }

      state.error = false;
      state.loadingBrandProducts = false;

      break;
    }
    case GET_MASTER_CATALOG_PRODUCTS_FAILED: {
      state.loadingBrandProducts = false;
      break;
    }
    case GET_CATEGORY_PRODUCTS_START: {
      state.categoryProductsLoading = true;
      break;
    }
    case CATEGORY_PRODUCTS_SUCCESS: {
      const {data, categoryId} = action;

      state.category_products[categoryId] = data;
      state.categoryProductsLoading = false;
      state.categoryProductsError = false;
      break;
    }
    case GET_CATEGORY_PRODUCTS_FAILED: {
      state.categoryProductsLoading = false;
      state.categoryProductsError = true;
      break;
    }
    case UPDATE_CATEGORY_PRODUCTS: {
      const {actionName, categoryId, product} = action;
      let selectedProducts = state.categories_products_to_update[categoryId]?.products || [];
      selectedProducts = selectedProducts.filter((p) => p.id !== product.id);

      if (actionName === 'remove-option') {
        state.category_products[categoryId].catalogProducts = state.category_products[categoryId].catalogProducts.filter((p) => p.id !== product.id);
        state.categories_products_to_update[categoryId] = {
          categoryId,
          products: [...selectedProducts, { id: product.id, action: 'remove'}]
        };
      }

      if (actionName === 'select-option') {
        state.category_products[categoryId].catalogProducts = [...state.category_products[categoryId].catalogProducts, product];
        state.categories_products_to_update[categoryId] = {
          categoryId,
          products: [...selectedProducts, { id: product.id, action: 'add'}]
        };
      }

      break;
    }
    case CHANGE_PRODUCT_CATEGORIES: {
      const {actionName, categoryId, product} = action;
      state.product_categories_to_update = state.product_categories_to_update.filter(({ categoryId: id }) => id != categoryId);

      if (actionName === 'remove-option') {
        state.selectedProductCategoriesIds = state.selectedProductCategoriesIds.filter((id) => id != categoryId);
        state.product_categories_to_update = [
          ...state.product_categories_to_update,
          {
            categoryId,
            products: [{ id: product.id, action: 'remove'}]
          }
        ];
      }

      if (actionName === 'select-option' && !state.selectedProductCategoriesIds.includes(categoryId)) {
        state.selectedProductCategoriesIds = [...state.selectedProductCategoriesIds, String(categoryId)];
        state.product_categories_to_update = [
          ...state.product_categories_to_update,
          {
            categoryId,
            products: [{ id: product.id, action: 'add'}]
          }
        ];
      }

      break;
    }
    case CREATE_STORE_CATEGORY_SUCCESS: {
      const {data} = action;
      state.product_categories_to_update = state.product_categories_to_update.filter(({ categoryId: id }) => id != data.id);
      state.selectedProductCategoriesIds = [...state.selectedProductCategoriesIds, String(data.id)];
      state.product_categories_to_update = [
        ...state.product_categories_to_update,
        {
          categoryId: data.id,
          products: [{ id: state.editable_store_product.id, action: 'add'}]
        }
      ];
      break;
    }
    case SAVE_CATEGORY_PRODUCTS_START: {
      state.updateCategoryProductsLoading = true;
      break;
    }
    case SAVE_CATEGORY_PRODUCTS_SUCCESS: {
      state.updateCategoryProductsLoading = false;
      break;
    }
    case SAVE_CATEGORY_PRODUCTS_FAILED: {
      state.updateCategoryProductsLoading = false;
      state.updateCategoryProductsError = true;
      break;
    }
    case SAVE_PRODUCT_CATEGORIES_START: {
      state.saveProductCategoriesLoading = true;
      break;
    }
    case SAVE_PRODUCT_CATEGORIES_SUCCESS: {
      state.saveProductCategoriesLoading = false;
      break;
    }
    case SAVE_PRODUCT_CATEGORIES_FAILED: {
      state.saveProductCategoriesLoading = false;
      state.saveProductCategoriesError = true;
      break;
    }
    case CREATE_NEW_SUBSCRIPTION_OPTION: {
      const {productId, optionId} = action;

      const editableSubscirption = state.subscriptionOptions.find((a) => a.id === optionId);
      state.newOption.product_id = productId;

      if (optionId) {
        state.newOption = {
          ...editableSubscirption,
          frequency_count: state.newOption.frequency_count || editableSubscirption.frequency_count,
          frequency_unit: state.newOption.frequency_unit || editableSubscirption.frequency_unit,
          sproduct_label: state.newOption.sproduct_label || editableSubscirption.sproduct_label,
          installment_price: state.newOption.installment_price || editableSubscirption.installment_price,
          additional_information: state.newOption.additional_information || editableSubscirption.additional_information,
          ssort_order: state.newOption.ssort_order || editableSubscirption.ssort_order
        };
      }

      break;
    }

    case EDIT_NEW_SUBSCRIPTION_OPTION: {
      const {productId, optionId, value} = action;
      const editableSubscirption = state.subscriptionOptions.find((a) => a.id === optionId);
      state.newOption.product_id = productId;

      if (optionId) {
        state.newOption = {
          ...editableSubscirption,
          frequency_count: value.frequency_count || editableSubscirption.frequency_count,
          frequency_unit: value.frequency_unit || editableSubscirption.frequency_unit,
          sproduct_label: value.sproduct_label || editableSubscirption.sproduct_label,
          installment_price: value.installment_price || editableSubscirption.installment_price,
          additional_information: value.additional_information || editableSubscirption.additional_information,
          ssort_order: value.ssort_order || editableSubscirption.ssort_order
        };
      }

      break;
    }
    case SET_SUBSCRIPTION_OPTIONS: {
      const {options} = action;
      state.subscriptionOptions = options;
      break;
    }
    case ADD_SUBSCRIPTION_OPTION_START: {
      state.addSubscriptionOptionLoading = true;
      break;
    }
    case ADD_SUBSCRIPTION_OPTION_SUCCESS: {
      const {data} = action;

      const subscriptions = data.map((option) => option.value.data);
      state.subscriptionOptions = [...state.subscriptionOptions, ...subscriptions];
      state.addSubscriptionOptionLoading = false;
      state.newOption = {};
      break;
    }
    case ADD_SUBSCRIPTION_OPTION_FAILED: {
      state.addSubscriptionOptionLoading = false;
      break;
    }
    case CHANGE_PRODUCT_SUBSCRIPTION_INSTALMENT_PRICE: {
      const {price} = action;

      if (state.subscriptionOptions.length !== 0) {
        state.subscriptionOptions = state.subscriptionOptions.map((option) => {
          const discountPercentage = option.additional_information.length
            ? JSON.parse(`${option.additional_information[0]}`).discount_percentage
            : 0;
          return {
            ...option,
            installment_price: (Number(price) * (100 - Number(discountPercentage))) / 100
          };
        });
      }

      break;
    }
    case CANCEL_ADD_SUBSCRIPTION_OPTION: {
      state.newOption = {};
      break;
    }
    case EDIT_SUBSCRIPTION_OPTION_START: {
      state.editSubscriptionOptionLoading = true;
      break;
    }
    case EDIT_SUBSCRIPTION_OPTION_SUCCESS: {
      const {options} = action;

      state.subscriptionOptions = state.subscriptionOptions.reduce((acc, option) => {
        const updatedOption = options.find((o) => o.id === option.id);

        if (updatedOption) {
          return [...acc, updatedOption];
        }

        return [...acc, option];
      }, []);
      state.editSubscriptionOptionLoading = false;
      break;
    }
    case EDIT_SUBSCRIPTION_OPTION_FAILED: {
      state.editSubscriptionOptionLoading = false;
      break;
    }
    case DELETE_SUBSCRIPTION_OPTION: {
      const {id} = action;
      state.subscriptionOptions = state.subscriptionOptions.filter((option) => option.id !== id);
      state.editSubscriptionOptionLoading = false;
      break;
    }
    case DELETE_ONE_TIME_SUBSCRIPTION_OPTION_START: {
      state.deleteOneTimeSubscriptionOptionLoading = true;
      break;
    }
    case DELETE_ONE_TIME_SUBSCRIPTION_OPTION_SUCCESS: {
      const {id} = action;
      state.subscriptionOptions = state.subscriptionOptions.filter((item) => item.id != id);
      state.deleteOneTimeSubscriptionOptionLoading = false;
      break;
    }
    case DELETE_ONE_TIME_SUBSCRIPTION_OPTION_FAILED: {
      state.deleteOneTimeSubscriptionOptionLoading = false;
      break;
    }
    case SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_START: {
      state.savingProductSubscriptionAttr = true;
      break;
    }
    case SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_SUCCESS: {
      const {product, attributeCode} =  action;

      const {value} = product.custom_attributes.find((attr) => attr.attribute_code === attributeCode);

      state.editable_store_product = {
        ...state.editable_store_product,
        custom_attributes: state.editable_store_product.custom_attributes.map((attr) => {
          return attr.attribute_code === attributeCode
            ? {...attr, value}
            : attr;
        })
      };
      state.savingProductSubscriptionAttr = false;
      break;
    }
    case SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_FAILED: {
      state.savingProductSubscriptionAttr = false;
      break;
    }
    case SET_CUSTOM_OPTIONS: {
      const {options} = action;
      state.productCustomOptions = options;
      break;
    }
    case ADD_CUSTOM_OPTION_START: {
      state.addCustomOptionLoading = true;
      break;
    }
    case ADD_CUSTOM_OPTION_SUCCESS: {
      const {data} = action;
      const updatedCustomOptions = [...state.productCustomOptions, data];

      state.editable_store_product = {
        ...state.editable_store_product,
        options: updatedCustomOptions.map((option) => (
          {
            product_sku: option.product_sku,
            title: option.title,
            sort_order: option.sort_order,
            type: option.type,
            is_require: option.is_require,
            max_characters: option.max_characters,
            image_size_y: option.image_size_y,
            image_size_x: option.image_size_x,
            option_id: option.option_id,
            values: option.values.map((optionValue) => ({
              title: optionValue.title,
              sort_order: optionValue.sort_order,
              price_type: optionValue.price_type,
              price: optionValue.price,
              option_type_id: optionValue.option_type_id
            }))
          }
        ))
      };
      state.productCustomOptions = [...state.productCustomOptions, data];
      state.addCustomOptionLoading = false;
      break;
    }
    case ADD_CUSTOM_OPTION_FAILED: {
      state.addCustomOptionLoading = false;
      break;
    }
    case DELETE_CUSTOM_OPTION_START: {
      state.deleteCustomOptionLoading = true;
      break;
    }
    case DELETE_CUSTOM_OPTION_SUCCESS: {
      const {id} = action;

      state.editable_store_product = {
        ...state.editable_store_product,
        options: state.editable_store_product.options.filter((option) => option.option_id !== id)
      };
      state.productCustomOptions = state.productCustomOptions.filter((option) => option.option_id !== id);
      state.deleteCustomOptionLoading = false;
      break;
    }
    case DELETE_CUSTOM_OPTION_FAILED: {
      state.deleteCustomOptionLoading = false;
      break;
    }
    case DELETE_CUSTOM_OPTION_VALUE_START: {
      state.deleteCustomOptionValueLoading = true;
      break;
    }
    case DELETE_CUSTOM_OPTION_VALUE_FAILED: {
      state.deleteCustomOptionValueLoading = false;
      break;
    }
    case EDIT_CUSTOM_OPTION_START: {
      state.editCustomOptionLoading = true;
      break;
    }
    case EDIT_CUSTOM_OPTION_SUCCESS: {
      const {option} = action;
      state.productCustomOptions = state.productCustomOptions.map((item) => item.option_id === option.option_id ? option : item);
      state.editCustomOptionLoading = false;
      break;
    }
    case EDIT_CUSTOM_OPTION_FAILED: {
      state.editCustomOptionLoading = false;
      break;
    }
    case DELETE_CUSTOM_OPTION_VALUE_SUCCESS: {
      const {options} = action;
      state.productCustomOptions = options;
      state.deleteCustomOptionValueLoading = false;
      break;
    }
    case GET_CUSTOM_OPTION_VALUE_BY_ID_START: {
      state.editCustomOptionLoading = true;
      break;
    }
    case GET_CUSTOM_OPTION_VALUE_BY_ID_FAILED: {
      state.editCustomOptionLoading = false;
      break;
    }
    case GET_CUSTOM_OPTION_VALUE_BY_ID_SUCCESS: {
      const {customOption} = action;
      state.editable_store_product.options = state.editable_store_product.options.map((item) => item.option_id === customOption.option_id ? customOption : item);
      state.editCustomOptionLoading = false;
      break;
    }
    case GET_CUSTOM_OPTIONS_PRICE_TYPES_START: {
      state.getCustomOptionPriceTypesLoading = true;
      break;
    }
    case GET_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS: {
      const {data} = action;
      state.customOptionPriceTypes = data;
      state.getCustomOptionPriceTypesLoading = false;
      break;
    }
    case GET_CUSTOM_OPTIONS_PRICE_TYPES_FAILED: {
      state.getCustomOptionPriceTypesLoading = false;
      break;
    }
    case SAVE_CUSTOM_OPTIONS_PRICE_TYPES_START: {
      state.saveCustomOptionPriceTypesLoading = true;
      break;
    }
    case SAVE_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS: {
      const {data} = action;
      state.customOptionPriceTypes = data;
      state.saveCustomOptionPriceTypesLoading = false;
      break;
    }
    case SAVE_CUSTOM_OPTIONS_PRICE_TYPES_FAILED: {
      state.saveCustomOptionPriceTypesLoading = false;
      break;
    }
    case ADD_PRODUCT_TO_STORE_START: {
      state.addProductToStoreLoading = true;
      break;
    }
    case ADD_PRODUCT_TO_STORE_SUCCESS: {
      const {product} = action;
      state.store_products.catalogProducts = [product, ...state.store_products.catalogProducts];
      state.addProductToStoreLoading = false;
      break;
    }
    case ADD_PRODUCT_TO_STORE_FAILED: {
      const {error, product} = action;
      console.log(error);
      state.addProductToStoreError = true;
      state.addProductToStoreLoading = false;
      state.failedPublishProducts = [...state.failedPublishProducts, product];
      break;
    }

    case MASS_ADD_PRODUCT_TO_STORE_START: {
      state.massAddProductToStoreLoading = true;
      break;
    }
    case MASS_ADD_PRODUCT_TO_STORE_SUCCESS: {
      const {products} = action;
      state.store_products.catalogProducts = [...products, ...state.store_products.catalogProducts];
      state.massAddProductToStoreLoading = false;
      break;
    }
    case MASS_ADD_PRODUCT_TO_STORE_FAILED: {
      state.massAddProductToStoreLoading = false;
      break;
    }

    case GET_FBT_LINKS_START: {
      state.getFBTDataLoading = true;
      state.getFBTDataError = '';
      break;
    }
    case GET_FBT_LINKS_SUCCESS: {
      const {data} = action;

      state.fbtData = data;
      state.getFBTDataLoading = false;
      state.getFBTDataError = '';
      break;
    }
    case GET_FBT_LINKS_FAILED: {
      const { error } = action;

      state.getFBTDataLoading = false;
      state.fbtData = [];
      state.getFBTDataError = error.response.data.error;
      break;
    }
    case SAVE_FBT_LINKS_START: {
      state.saveFBTLinksLoading = true;
      break;
    }
    case SAVE_FBT_LINKS_SUCCESS: {
      const {data} = action;

      state.fbtData = [...state.fbtData, ...data];
      state.saveFBTLinksLoading = false;
      break;
    }
    case SAVE_FBT_LINKS_FAILED: {
      state.saveFBTLinksLoading = false;
      break;
    }
    case REMOVE_FBT_LINK_START: {
      state.removeFBTLinksLoading = true;
      break;
    }
    case REMOVE_FBT_LINK_SUCCESS: {
      const {linkedProductSku} = action;

      state.fbtData = state.fbtData.filter((item) => item.linked_product_sku != linkedProductSku);
      state.removeFBTLinksLoading = false;
      break;
    }
    case REMOVE_FBT_LINK_FAILED: {
      state.removeFBTLinksLoading = false;
      break;
    }
    case ADD_UPSELL_LINKS: {
      const {data} = action;

      state.editable_store_product.product_links = [...state.editable_store_product.product_links, data];
      break;
    }
    case ADD_CROSS_SELL_LINKS: {
      const {data} = action;

      state.editable_store_product.product_links = [...state.editable_store_product.product_links, data];
      break;
    }
    case SEND_DIRECT_FULFILLMENT_REQUEST_START: {
      state.sendingFulfillmentRequest = true;
      break;
    }
    case SEND_DIRECT_FULFILLMENT_REQUEST_SUCCESS: {
      state.sendingFulfillmentRequest = false;
      break;
    }
    case SEND_DIRECT_FULFILLMENT_REQUEST_FAILED: {
      state.sendingFulfillmentRequest = false;
      break;
    }
    case GET_STORE_PRODUCTS_EXPORT_START: {
      state.loadingProductsExport = true;
      break;
    }
    case GET_STORE_PRODUCTS_EXPORT_SUCCESS: {
      const {data} = action;

      state.storeProductsExport = data.data;
      state.loadingProductsExport = false;

      break;
    }
    case GET_STORE_PRODUCTS_EXPORT_FAILED: {
      state.loadingProductsExport = false;
      break;
    }

    case ADD_TO_MASS_EDIT: {
      const {products, productsType} = action;
      state.massEdit = { list: products, changedProductIds: null, productsType };
      break;
    }

    case SAVE_STORE_PRODUCT_MEDIA_GALLERY_START: {
      state.savingProductMediaGallery = true;
      break;
    }
    case SAVE_STORE_PRODUCT_MEDIA_GALLERY_SUCCESS: {
      const {product} =  action;

      const baseImageValue = product.media_gallery_entries.find((media) => media.types.includes('image'))?.file || '';
      const baseSmallImageValue = product.media_gallery_entries.find((media) => media.types.includes('small_image'))?.file || '';
      const baseThumbnailValue = product.media_gallery_entries.find((media) => media.types.includes('thumbnail'))?.file || '';

      const customAttributes = product.custom_attributes.map((attr) => {
        if (attr.attribute_code === 'image') {
          return {...attr, value: baseImageValue};
        }

        if (attr.attribute_code === 'small_image') {
          return {...attr, value: baseSmallImageValue};
        }

        if (attr.attribute_code === 'thumbnail') {
          return {...attr, value: baseThumbnailValue};
        }

        return attr;
      });

      state.editable_store_product = {
        ...state.editable_store_product,
        custom_attributes: customAttributes,
        media_gallery_entries: product.media_gallery_entries
      };
      state.savingProductMediaGallery = false;
      break;
    }
    case SAVE_STORE_PRODUCT_MEDIA_GALLERY_FAILED: {
      state.savingProductMediaGallery = false;
      break;
    }

    case GET_STORE_TAX_CLASSES_START: {
      state.loadingTaxClasses = true;
      break;
    }
    case GET_STORE_TAX_CLASSES_SUCCESS: {
      const {data} = action;
      state.storeTaxClasses = data.items;
      state.loadingTaxClasses = false;
      break;
    }
    case GET_STORE_TAX_CLASSES_FAILED: {
      state.loadingTaxClasses = false;
      break;
    }


    case GET_ALL_TASKS_FROM_QUEUE_START: {
      break;
    }
    case GET_ALL_TASKS_FROM_QUEUE_SUCCESS: {
      const {data, storeViewCode} = action;

      state.queueTasks[storeViewCode] = data.filter((t) => t.storeViewCode === storeViewCode);

      state.queueTasksSkus[storeViewCode] = state.queueTasks[storeViewCode].map((t) => t.sku);

      break;
    }
    case GET_ALL_TASKS_FROM_QUEUE_FAILED: {
      break;
    }
    case ADD_TASKS_TO_QUEUE_START: {
      state.loadingTasksToQueue = true;
      break;
    }
    case ADD_TASKS_TO_QUEUE_SUCCESS: {
      state.loadingTasksToQueue = false;
      break;
    }
    case ADD_TASKS_TO_QUEUE_FAILED: {
      state.loadingTasksToQueue = false;
      break;
    }
    case REMOVE_TASK_FROM_QUEUE_START: {
      break;
    }
    case REMOVE_TASK_FROM_QUEUE_SUCCESS: {
      break;
    }
    case REMOVE_TASK_FROM_QUEUE_FAILED: {
      break;
    }

    case RECEIVE_QUEUED_TASK_UPDATE: {
      const {action: taskAction, task, resultData, task: {storeViewCode} } = action.data;

      state.queueTasks[storeViewCode] = state.queueTasks[storeViewCode] || [];
      state.queueTasksSkus[storeViewCode] = state.queueTasksSkus[storeViewCode] || [];

      const isStore = !storeViewCode.includes('quote');

      if (taskAction === 'TASK_ADDED') {
        const taskAlreadyExists = state.queueTasks[storeViewCode].some((t) => t._id === task._id);

        if (!taskAlreadyExists) {
          state.queueTasks[storeViewCode] = [...state.queueTasks[storeViewCode], task];
          state.queueTasksSkus[storeViewCode] = [...state.queueTasksSkus[storeViewCode], task.sku];
        }
      } else if (taskAction === 'TASK_UPDATED') {
        state.queueTasks[storeViewCode] = state.queueTasks[storeViewCode].map((t) => t._id === task._id ? task : t);
      } else if (taskAction === 'TASK_COMPLETED') {
        state.queueTasks[storeViewCode] = state.queueTasks[storeViewCode].filter((t) => t._id !== task._id);
        state.queueTasksSkus[storeViewCode] = state.queueTasks[storeViewCode].map((t) => t.sku);

        if (isStore) {
          if (task.requestType === 'CREATE_PRODUCT' || task.requestType === 'UPDATE_PRODUCT_TO_ADD_STOREVIEW') {
            state.store_products.catalogProducts = [resultData, ...state.store_products.catalogProducts];
            state.store_products.store_products_sku = [...state.store_products.store_products_sku, task.sku];
            state.store_products.catalogActiveProducts = [...state.store_products.catalogActiveProducts, task.sku];
          } else if (task.requestType === 'UPDATE_PRODUCT') {
            state.store_products.catalogProducts = state.store_products.catalogProducts.map((p) => p.sku === resultData.sku ? resultData : p);
          } else if (task.requestType === 'DELETE_PRODUCT' || task.requestType === 'UPDATE_PRODUCT_TO_DELETE_STOREVIEW') {
            state.store_products.catalogProducts = state.store_products.catalogProducts.filter((p) => p.sku !== task.sku);
            state.store_products.store_products_sku = state.store_products.store_products_sku.filter((sku) => sku !== task.sku);
            state.store_products.catalogActiveProducts = state.store_products.catalogActiveProducts.filter((sku) => sku !== task.sku);
          }
        }

        if (!isStore &&
          (task.requestType === 'UPDATE_PRODUCT_TO_ADD_STOREVIEW' || task.requestType === 'UPDATE_PRODUCT_TO_DELETE_STOREVIEW')
        ) {
          state.store_products.catalogProducts = state.store_products.catalogProducts.map((p) => {
            if (p.sku === resultData.sku) {
              const updatedProductWebsiteIds = resultData.extension_attributes.website_ids;
              return {...p, extension_attributes: { ...p.extension_attributes, website_ids: updatedProductWebsiteIds }};
            }

            return p;
          });
        }
      } else if (taskAction === 'TASK_REMOVED') {
        state.queueTasks[storeViewCode] = state.queueTasks[storeViewCode].filter((t) => t._id !== task._id);
        state.queueTasksSkus[storeViewCode] = state.queueTasks[storeViewCode].map((t) => t.sku);
      }

      break;
    }
    case ADD_PATIENT_CERTIFICATION_START: {
      state.loadingPatientCertification = true;
      break;
    }
    case ADD_PATIENT_CERTIFICATION_SUCCESS: {
      const {data} = action;

      state.productCustomOptions = [...state.productCustomOptions, data];
      state.loadingPatientCertification = false;
      break;
    }
    case ADD_PATIENT_CERTIFICATION_FAILED: {
      state.loadingPatientCertification = false;
      break;
    }
    case EDIT_PATIENT_CERTIFICATION_START: {
      state.loadingPatientCertification = true;
      break;
    }
    case EDIT_PATIENT_CERTIFICATION_SUCCESS: {
      const {data} = action;

      // Matched on option_id: template-driven certifications share an empty option_title_id, so
      // matching on that would overwrite every one of them with the option just edited.
      state.productCustomOptions = state.productCustomOptions.map((el) => el.option_id === data.option_id ? data : el);
      state.patientCertification = state.patientCertification.map((el) => (
        el.option_title_id && el.option_title_id === data.option_title_id ? data : el
      ));
      state.loadingPatientCertification = false;
      break;
    }
    case EDIT_PATIENT_CERTIFICATION_FAILED: {
      state.loadingPatientCertification = false;
      break;
    }
    case SET_PATIENT_CERTIFICATION_START: {
      state.loadingPatientCertification = true;
      break;
    }
    case SET_PATIENT_CERTIFICATION_SUCCESS: {
      const {data} = action;

      // The store returns every option of the product after the change, so the list is replaced
      // rather than patched: enabling a certification can materialize options from a template.
      state.productCustomOptions = data;
      state.loadingPatientCertification = false;
      break;
    }
    case SET_PATIENT_CERTIFICATION_FAILED: {
      state.loadingPatientCertification = false;
      break;
    }
    case DELETE_PATIENT_CERTIFICATION_START: {
      state.loadingPatientCertification = true;
      break;
    }
    case DELETE_PATIENT_CERTIFICATION_SUCCESS: {
      const {data} = action;

      state.productCustomOptions = state.productCustomOptions.filter((el) => el.option_id !== data.option_id);
      state.loadingPatientCertification = false;
      break;
    }

    case DELETE_PATIENT_CERTIFICATION_FAILED: {
      state.loadingPatientCertification = false;
      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.store_products = {
        catalogProducts: [],
        store_products_sku: [],
        catalogActiveProducts: [],
        count: 0
      };
      state.queueTasks = initialState.queueTasks;
      state.queueTasksSkus = initialState.queueTasksSkus;

      break;
    }

    case ADD_USER_STORE_SUCCESS: {
      state.store_products = {
        catalogProducts: [],
        store_products_sku: [],
        catalogActiveProducts: [],
        count: 0
      };
      state.queueTasks = initialState.queueTasks;
      state.queueTasksSkus = initialState.queueTasksSkus;

      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
